// Koersive Zahlenformatter für die ASIN-Targeting-Tabelle.
// Backend liefert numeric-Spalten teils als String; diese Formatter
// akzeptieren number | string und crashen nie (der ursprüngliche
// /asin-targeting-White-Screen entstand durch String.toFixed()).

function toNum(n: number | string | null | undefined): number | null {
  if (n === null || n === undefined) return null
  const num = typeof n === 'number' ? n : Number(n)
  return Number.isNaN(num) ? null : num
}

export function fmtEur(n: number | string | null | undefined): string {
  const num = toNum(n)
  if (num === null) return '—'
  return num.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function fmtPct(n: number | string | null | undefined): string {
  const num = toNum(n)
  if (num === null) return '—'
  return `${num.toFixed(1)}%`
}

export function fmtInt(n: number | string | null | undefined): string {
  const num = toNum(n)
  if (num === null) return '—'
  return num.toLocaleString('de-DE')
}
